module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3 class="center">\r\n\r\n    ';
 if (baseParentIdPath){ 
__p+='\r\n    <a href="'+
((__t=( parentUrl ))==null?'':__t)+
'" target="_blank">\r\n    ';
 } 
__p+='\r\n\r\n        '+
((__t=( documentName ))==null?'':__t)+
'\r\n\r\n    ';
 if (baseParentIdPath){ 
__p+='\r\n    </a>\r\n    ';
 } 
__p+='\r\n\r\n\r\n</h3>\r\n<div class="col-md-offset-1 col-xs-offset-1 col-md-10 col-xs-10">\r\n    <table class="table table-hover top-margined">\r\n        <thead>\r\n        <tr>\r\n            <th>Time</th>\r\n            <th>Event type</th>\r\n            <th>User</th>\r\n            <th>Audit comment</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n    </table>\r\n</div>\r\n\r\n<div id="marked-as-delivered-confirmation-modal"></div>\r\n<div id="mark-as-signed-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/history/document-history-table.html
// module id = 420
// module chunks = 0